// Swaps the Spotify facade rendered by sections/hc-html.liquid for the real player
// on click, or when the section scrolls near the viewport, so Spotify's player
// bundle never loads with the initial page.
(() => {
  const loadPlayer = (facade) => {
    if (facade.dataset.loaded) return;
    facade.dataset.loaded = "true";

    const iframe = document.createElement("iframe");
    iframe.src = facade.dataset.spotifySrc;
    iframe.title = facade.dataset.spotifyTitle;
    iframe.width = "100%";
    iframe.height = facade.dataset.spotifyHeight;
    iframe.allow =
      "autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture";
    iframe.loading = "lazy";
    facade.replaceChildren(iframe);
  };

  const init = () => {
    const facades = document.querySelectorAll(".spotify-facade:not([data-loaded])");
    if (!facades.length) return;

    const observer =
      "IntersectionObserver" in window
        ? new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                observer.unobserve(entry.target);
                loadPlayer(entry.target);
              });
            },
            { rootMargin: "200px" }
          )
        : null;

    facades.forEach((facade) => {
      facade
        .querySelector(".spotify-facade__button")
        ?.addEventListener("click", () => loadPlayer(facade), { once: true });
      if (observer) {
        observer.observe(facade);
      } else {
        loadPlayer(facade);
      }
    });
  };

  init();
  document.addEventListener("shopify:section:load", init);
})();
